export enum USER_AUTH_TYPE {
  COMARCH_EMPLOYEE = 'b2c_1a_signin_comarchemployee',
  COMARCH_CUSTOMER = 'b2c_1a_signin_practicebuilderinvite'
}